<form [formGroup]="user" id="user-details" (ngSubmit)="onSubmit(user)">
    <div class="modal-header m-transparent">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
     </div>
  <div class="modal-header">
    <div class="d-flex justify-content-center1 text-center">
      <h3 class="modal-title">{{'HELP_DIALOG.TITLE' | translate}}</h3>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="errorMessage" class="d-flex flex-column align-items-center text-center">
      <div class="m-1 m-error">
        {{errorMessage}}
      </div>
    </div>
    <div class="d-flex flex-column align-items-center text-center">
      <div class="m-1">
        <input type="text" class="m-form-control" placeholder="{{'HELP_DIALOG.FIRST_NAME_PC'|translate}}" formControlName="firstName">
        <div class="m-error" *ngIf="user.get('firstName').hasError('required') && submitted">
          {{ 'HELP_DIALOG.FIRST_NAME_REQUIRED' | translate }}
        </div>
        <div class="m-error" *ngIf="user.get('firstName').hasError('pattern') && submitted">
          {{ 'HELP_DIALOG.NAME_ERROR' | translate }}
        </div>
      </div>
      <div class="m-1">
        <input type="text" class="m-form-control" placeholder="{{'HELP_DIALOG.LAST_NAME_PC'|translate}}" formControlName="lastName">
        <div class="m-error" *ngIf="user.get('lastName').hasError('required') && submitted">
          {{ 'HELP_DIALOG.LAST_NAME_REQUIRED' | translate }}
        </div>
        <div class="m-error" *ngIf="user.get('lastName').hasError('pattern') && submitted">
          {{ 'HELP_DIALOG.NAME_ERROR' | translate }}
        </div>
      </div>
      <div class="m-1">
        <input class="m-form-control" type="tel" maxlength="9" placeholder="{{'HELP_DIALOG.ID_NUMBER_PC'|translate}}" formControlName="idNumber"
          maxlength="9">
        <div class="m-error" *ngIf="user.get('idNumber').hasError('required') && submitted">
          {{ 'HELP_DIALOG.ID_REQUIRED' | translate }}
        </div>
        <div class="m-error" *ngIf="user.get('idNumber').hasError('invalidId') && !user.get('idNumber').hasError('required') && submitted">
          {{'HELP_DIALOG.ID_ERROR' | translate }}
        </div>
      </div>
      <div class="m-1">
        <phone-number [customClass]="'help-dialog'" formControlName="phoneNumber" [(isMobile)]="isMobilePhone" (change)="updateValidators($event.target.value)"
          [attr.aria-label]="'HELP_DIALOG.PHONE_NUMBER_PC' | translate" [attr.aria-invalid]="!user.get('phoneNumber').valid &&  submitted">
        </phone-number>
        <div class="m-error" *ngIf="user.get('phoneNumber').hasError('minlength') && submitted">
          {{ 'HELP_DIALOG.TEL_ERROR' | translate }}
        </div>
        <div class="m-error" *ngIf="user.get('phoneNumber').hasError('required') && submitted">
          {{ 'HELP_DIALOG.TEL_ERROR' | translate }}
        </div>
        <div class="m-error" *ngIf="user.get('phoneNumber').hasError('pattern') && submitted">
          {{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
        </div>
      </div>
      <div>
        <button type="submit" class="btn btn-primary">{{"COMMON.SEND"|translate}}</button>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
      <p>{{'HELP_DIALOG.MSG' | translate}}</p>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/help-dialog/help-dialog.component.html